var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports-wrapper"},[_c('div',[_c('generate-report')],1),_c('div',[_c('generated-reports-listing',{staticClass:"generated-report-listing"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }